var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list&&_vm.list.length)?_c('div',{staticClass:"classification cl center-box"},_vm._l((_vm.list),function(item){return _c('router-link',{key:item.id,staticClass:"item",style:({backgroundImage:`url(${item.photoUrl})`}),attrs:{"to":{name:'ThemeTravel',query:{classification:item.businessId}}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }